<template>
  <RadioButton
    @input="selectCourierDelivery"
    :value="value"
    :option="option"
    class="rd-card mt-10 heading-4 weight-medium"
    title='In Person at a Contact Point'
    :checked="selected">
    <template v-slot:info>
      <p class="body-3 mt-5">
        You can sign the application form at one of our contact points, which you can choose.
      </p>
    </template>
    <template v-slot:default>
      <div>
        <InfoBox class="mt-5 ib-warning" :icon="require('@/assets/svg/alert-icon.svg')">
          <p class="m-0 pr-md-5 weight-regular body-3">
            
    <b>How does it work?</b>
    <ul class="p-0">
        <li>
            We will notify you by e-mail when your application has been received by the contact point of your choice.
        </li>
        <li>
            The application form will be waiting for you at the selected contact point for 3 business days.
        </li>
        <li>
            If your application has not been signed within 3 days, you will be contacted by our call centre to propose other options for completing your application.
        </li>
    </ul>
  
          </p>
        </InfoBox>
        <h4 class="weight-medium my-10">
          Deliver the application form to:
        </h4>

        <div class="input-box-holder" v-validate="errors">
          <SelectField
            class="input-box"
            title='Select a contact point:'
            placeholder='Select from the List'
            :options="contactPlaces"
            :value="contactPlace"
            @input="setContactPlace"
            required
            valueOnlyFromOptions
          />
          <div class="validation-output text-left mt-2">
            <ErrorHandler class="error" id="V093">
              Select a contact point.
            </ErrorHandler>
          </div>
        </div>

        <div class="input-box-holder" v-validate="errors">
          <TextField
            class="input-box mt-5"
            title='Enter Your E-mail to Receive a Notification'
            :value="model.insurer.email"
            @change="setEmail"
            required
          />
          <div class="validation-output text-left mt-2">
            <ErrorHandler class="error" id="V090">
              Enter your e-mail.
            </ErrorHandler>

            <ErrorHandler class="error" id="V091">
              Enter your e-mail in the correct format.
            </ErrorHandler>

            <ErrorHandler class="error" id="V092">
              The maximum number of characters is 50.
            </ErrorHandler>
          </div>
        </div>
      </div>
    </template>
  </RadioButton>
</template>
<script>
import RadioButton from '@/components/RadioButton/RadioButton.vue';
import enums from '@/mixins/enums';
import distributionChannels from '@/mixins/distributionChannels';
import persons from '@/mixins/persons';
import SelectField from '@/components/SelectField/SelectField.vue';
import TextField from '@/components/TextField/TextField.vue';
import InfoBox from '@/components/InfoBox/InfoBox.vue';
import ErrorHandler from '@/components/ErrorHandler/ErrorHandler.vue';
import address from '@/mixins/address';

export default {
  components: {
    ErrorHandler,
    InfoBox,
    TextField,
    SelectField,
    RadioButton,
  },
  mixins: [enums, distributionChannels, persons, address],
  props: {
    value: {
      type: Object,
      required: false,
    },
    option: {
      type: Object,
      required: true,
    },
    delivery: { required: true, type: Object },
    model: { required: true, type: Object },
    selected: { required: false, type: Boolean, default: false },
    errors: { type: Array, required: true },
  },
  methods: {
    selectCourierDelivery(value) {
      this.$emit('input', value);
    },
    setContactPlace(place) {
      this.delivery.contactPlace = { email: place?.email, id: place?.id, number: place?.number };
      if (place) {
        this.delivery.contactPlace.address = {
          city: place.city, zip: place.zip, street: place.address, country: this.$store.getters.getSlovakia,
        };
      } else {
        this.delivery.contactPlace.address = this.createNewAddress();
      }
    },
    setEmail(email) {
      this.model.insurer.email = email.replace(/\s+/g, '');
      this.model.delivery.email = email.replace(/\s+/g, '');
    },
  },
  computed: {
    contactPlaces() { return this.$store.state.contactPlaces; },
    contactPlace() { return this.contactPlaces?.find((place) => place.id === this.delivery.contactPlace?.id); },
  },
  created() {
    if (!this.model.isMobile) {
      this.delivery.eSignatureDevice = this.enums.DeviceEnum.ON_ANOTHER_DEVICE;
    }
  },
};
</script>
